// export const environment = {
//   production: true
// };

// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  isLocal: false,
  firebase: {
    apiKey: "AIzaSyDnaIiLGP3ojSAy2ghCjK4rMfuIfd3R0as",
    authDomain: "api-project-138618482810.firebaseapp.com",
    vapidKey: "BEC5OHQTxGu3IQaL9_ueaYcbx6lQigztlGMJm4nzzH3MuQa6G3NDuDVv2avEU5i6I50Sqjdcbv1gyS8URfI1GLw",
    projectId: "api-project-138618482810",
    storageBucket: "api-project-138618482810.firebasestorage.app",
    messagingSenderId: "138618482810",
    appId: "1:138618482810:web:22ac0f0d7dc5924c5a0bc3",
    measurementId: "G-5NVEB1KT3V"
  },
  urlAPI: 'https://api.kc.edutin.com/b/d',
  urlAPIBusiness: 'https://api.kc.edutin.com/bus/d',
  urlFormsApi: 'https://api.kc.edutin.com/fm/d',
  urlStorageApi: 'https://api.kc.edutin.com/s/d',
  urlCvApi: 'https://api.kc.edutin.com/cv/d',
  domain: 'https://7428c012-617a-4a8e-8f03-43e12a0d40de.edutin.com',
  urlAdDomain: 'https://aviewerdev.edutin.com',
  appDomain: 'https://06de1684-edc7-4172-947e-45f6d1146fb4.edutin.com',
  redirectSignIn: "https://06de1684-edc7-4172-947e-45f6d1146fb4.edutin.com/home/",
  redirectSignOut: "https://ruy407jd.accounts.edutin.com/accounts",
  authAppUrl: "https://ruy407jd.accounts.edutin.com",
  locationEndPoint: 'https://d2qff10pjfk7uz.cloudfront.net/b/d/users/location',
  appSync: {
    http: 'https://axtfx3wo55fatclo7muikvtjae.appsync-api.us-east-1.amazonaws.com/graphql',
    ws: 'wss://axtfx3wo55fatclo7muikvtjae.appsync-realtime-api.us-east-1.amazonaws.com/graphql',
    host: 'axtfx3wo55fatclo7muikvtjae.appsync-api.us-east-1.amazonaws.com'
  },
  appSyncEvents: {
    http: 'https://ubjqxa7frrdnfoppsh5katrz5m.appsync-api.us-east-1.amazonaws.com/event',
    ws: 'wss://ubjqxa7frrdnfoppsh5katrz5m.appsync-realtime-api.us-east-1.amazonaws.com/event/realtime',
    host: 'ubjqxa7frrdnfoppsh5katrz5m.appsync-api.us-east-1.amazonaws.com'
  },
  presenceWs: {
    ws: 'wss://1hut64zmu4.execute-api.us-east-1.amazonaws.com/dev'
  },
  customRoutesUrl: 'https://d3puay5pkxu9s4.cloudfront.net/Resources/custom-certifications/custom-routes.json',
  noDniUsersUrl: 'https://d3puay5pkxu9s4.cloudfront.net/Resources/custom-certifications/no-dni-users.json',
  customCertificationsUrl: 'https://d3puay5pkxu9s4.cloudfront.net/Resources/custom-certifications/custom-certifications.json',
  authApi: 'https://kyclk.edutin.com/realms/edutin',
  assistApp: "https://tempassist.edutin.com/",
  designerApp: "https://design.edutin.com/",
  businessApp: "https://devbusiness.edutin.com",
  affiliateApp: "https://devaffiliate.edutin.com/",

  // Micro-frontend (Native Federation)
  useFederation: true,
  remoteChatMfeUrl: 'https://otaqovxoetifrcsvqehzrtmc.edutin.com',

  whatsappLink: 'https://wa.me/+13022615750?text=',
  // Oculta los puntos de entrada de UI al chat legacy (nav-bar, groups) sin borrar su código.
  // Independiente de useFederation: permite apagar el legacy y activar el MFE por separado.
  hideLegacyChat: true,
};


/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
